import { Injectable } from '@angular/core';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service'
import { Observable, map } from 'rxjs';
import { SnapshotService } from '../../../Services/snapshot.service';
@Injectable({
  providedIn: 'root'
})
export class BarserviceService {
  customizeLegend(chart: any, showlegend: any, legendPos: any, properties: any,height:any="",popUp:any=false): Highcharts.LegendOptions {

    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'center';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';
    let maxHeight = undefined;
    if (showlegend) {
      switch (legendPos) {
        case "top":
          alignLegend = 'top';
          alignx = 'left';
          layout1 = 'horizontal';
          break;
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          maxHeight = maxHeight;
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          maxHeight = maxHeight;
          break;
        default:
          // No need to change anything for the default case
          break;
      }
    }

    return {
      enabled: showlegend,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      y:popUp? -5:0,
      navigation: {
        activeColor: '#7f7f7f',
        animation: true,
        arrowSize: 10,
        inactiveColor: '#ccc',
        enabled:properties.legendPosition != "bottom"?true:true
      },
      itemMarginBottom: properties.legendPosition != "bottom" ? 0 : 0,
      itemMarginTop: properties.legendPosition != "bottom" ? 0 : 0,
      maxHeight: properties.legendPosition != "bottom" ?maxHeight:55,
      itemStyle: {
        color: properties.darkTheme ? "white" : "black",
        fontWeight: "normal",
        fontSize: '0.8em',
        cursor: 'pointer'
      },
      symbolWidth: legendPos=="bottom"?10:0,  // Set to a valid non-negative value
      symbolHeight: legendPos=="bottom"?10:0, 
      itemHiddenStyle: {
        color: "grey",
      },
      useHTML:legendPos!="bottom"?true:false,
      // (height != "20em" ? '40px' : '19.5rem')
      labelFormatter: function (): any {
        let point = this as any;
        let textcolor = properties.darkTheme ? 'white' : 'black';
        if (point.color != "#eeebed" && point.color != "#7f7f7f") {
          return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + point.name + '">'
            + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
            + '<div style="width:' + (height != "22em" ? '4rem' : '10rem') + ';height:20px;padding-left:4px;padding-top:5px;color:' + textcolor + ';overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
            + '</div>';
        }
      },

    };
  }
  axisLabelOrientation(axisLabelOrientation: any) {
    let rotationValue = 0;
    switch (axisLabelOrientation) {
      case 'vertical':
        rotationValue = -90; // or 90 depending on your preference
        break;

      case 'horizontal':
        rotationValue = 0;
        break;
      case 'angled':
        rotationValue = -60;
        break;

      default:
        rotationValue = 0;
        break;
    }
    return rotationValue
  }

  constructor(private commonchartmodules: CommonChartmoduleService, private _configService: SnapshotService) { }
  properties: any;
  seriesData1: any[] = [];
  colorIndex = 0;
  // color1: string[] = ["#9BC5E5", "#D5BCE4", "#F9C099", "#FF97A8", "#A6E2D7",
  //   "#BDE6BD", "#BFE1FD", "#F4E4B3", "#CD978B", "#EAC4D5",
  //   "#FFCC99", "#6699CC", "#FF9999", "#66CCCC", "#FF9966",
  //   "#99CC66", "#FF99CC", "#CCCC99", "#FF9966", "#FFCC66",
  //   "#99CC99", "#FFCC00", "#99CCFF", "#FF6666", "#CCCC66"];
  // color1: string[] = [
  //   "#0255cc", "#00b6ff", "#00e5ba", "#9ee900",
  //   "#00b600", "#2f6d2f", "#802ab7", "#c700d3",
  //   "#eb0064", "#eb0064", "#fedb00", "#847b4f",
  //   "#83c4b6", "#4d839e", "#aa91c4", "#f8ac8f",
  //   "#f2cf61", "#647032", "#4e4376", "#5a6670",
  //   "#003a5d", "#2d7f6f", "#453635", "#b75553",
  //   "#b8aaa2", "#ebdec5", "#c4c5c9", "#ddc2b7",
  //   "#d6ae7b", "#492a07"
  // ];
  color1:string[]=this.commonchartmodules.color1;
  // color1: string[] = [
  //   "#9bc5e5",
  //   "#d5bce4",
  //   "#ff97a8",
  //   "#a7e2d7",
  //   "#ffcc66",
  //   "#ff9966",
  //   "#6799cc",
  //   "#cdcc66",
  //   "#f4e4b3",
  //   "#47b7ae",
  //   "#f9c099",
  //   "#7fb6c6",
  //   "#2c70a3",
  //   "#d6a365",
  //   "#802ab7",
  //   "#00b6ff",
  //   "#417f54",
  //   "#bf5c9e",
  //   "#62849b",
  //   "#e5ce85",
  //   "#ae3875",
  //   "#6750a4",
  //   "#798987",
  //   "#b2f9ee",
  //   "#dd8340",
  //   "#2d97a5",
  //   "#bd78ef",
  //   "#af7f4f",
  //   "#7f5aa3",
  //   "#5c752d"
  // ];

  patternImages = ['assets/Images/BarChart/Chart library_pattern colour 1.png', 'assets/Images/BarChart/Chart library_pattern colour 2.png', 'assets/Images/BarChart/Chart library_pattern colour 3.png', 'assets/Images/BarChart/Chart library_pattern colour 4.png', 'assets/Images/BarChart/Chart library_pattern colour 5.png', 'assets/Images/BarChart/Chart library_pattern colour 6.png', 'assets/Images/BarChart/Chart library_pattern colour 7.png', 'assets/Images/BarChart/Chart library_pattern colour 8.png', 'assets/Images/BarChart/Chart library_pattern colour 9.png', 'assets/Images/BarChart/Chart library_pattern colour 10.png', 'assets/Images/BarChart/Chart library_pattern colour 11.png', 'assets/Images/BarChart/Chart library_pattern colour 12.png', 'assets/Images/BarChart/Chart library_pattern colour 13.png', 'assets/Images/BarChart/Chart library_pattern colour 14.png', 'assets/Images/BarChart/Chart library_pattern colour 15.png', 'assets/Images/BarChart/Chart library_pattern colour 16.png', 'assets/Images/BarChart/Chart library_pattern colour 17.png', 'assets/Images/BarChart/Chart library_pattern colour 18.png', 'assets/Images/BarChart/Chart library_pattern colour 19.png', 'assets/Images/BarChart/Chart library_pattern colour 20.png', 'assets/Images/BarChart/Chart library_pattern colour 21.png', 'assets/Images/BarChart/Chart library_pattern colour 22.png', 'assets/Images/BarChart/Chart library_pattern colour 23.png', 'assets/Images/BarChart/Chart library_pattern colour 24.png', 'assets/Images/BarChart/Chart library_pattern colour 2.png'];

  linearGradients: any = this.color1.map((color, index) => {
    const darkerShade = this.getDarkerShade(color);
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  });
  textfont = 'KantarBrown-Regular';
  //colors: string[] = ['red', 'blue', 'orange', '#BDE6BD', 'purple', 'brown', 'pink', 'cyan', 'blue']; // Add more colors as needed
  colors : string[] = ["#9bc5e5", "#d5bce4", "#ff97a8","#a7e2d7","#ffcc66","#ff9966","#6799cc","#cdcc66","#f4e4b3","#47b7ae","#f9c099","#7fb6c6","#2c70a3","#d6a365","#802ab7","#00b6ff","#417f54","#bf5c9e","#62849b"]
  darkThemeBackgroundColor = '#333';
  defaultThemeBackgroundColor = 'white';
  darkThemeTextColor = 'white';
  defaultThemeTextColor = 'black';
  defaultCategories = ['', 'Brand 1', 'Brand 2', 'Brand 3', 'Brand 4', 'Brand 5', 'Brand 6', 'Brand 7', 'Brand 8', 'Brand 9', 'Brand10'];
  defaultCategoriesCluster = ['Brand 1', 'Brand 2', 'Brand 3', 'Brand 4', 'Brand 5', 'Brand 6', 'Brand 7', 'Brand 8', 'Brand 9'];
  transparentBackground = 'transparent';
  upwardTriangle = '&#9650';
  downwardTriangle = '\u25BC';
  highSignificance = 'green';
  lowSignificance = 'red';
  changeValueFontSize = "80%";
  sampleSizeConstant = 9000;
  maxLabelCharacters = 4;

  baseImgPath = "assets/Images/BarChart/"



  lowSampleText = "LS";
  nullValueText = "NA";


  shadowColor = 'rgba(0, 0, 0, 0.5)';
  getDarkerShade(color: any) {
    const darkenFactor = 0.7; // Adjust this factor for a darker shade
    const rgb = color.substring(1); // Remove the '#' from the color
    const r = parseInt(rgb.substring(0, 2), 16);
    const g = parseInt(rgb.substring(2, 4), 16);
    const b = parseInt(rgb.substring(4, 6), 16);
    const darkerR = Math.round(r * darkenFactor);
    const darkerG = Math.round(g * darkenFactor);
    const darkerB = Math.round(b * darkenFactor);
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
  }


  list: any;
  VerticalBarcustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Vertical Bar Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist()]
        return custom;
      })
    );
  }
  VerticalClusterBarcustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Vertical Cluster Bar")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist()]
        return custom;
      })
    );
  }
  HorizontalBarcustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Horizontal Bar Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist()]
        return custom;
      })
    );
  }
  HorizontalClusterBarcustomizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Horizontal Clustered Bar")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist()]
        return custom;
      })
    );
  }

  applycustomization(event: any, item: any, properties: any) {
    this.commonchartmodules.applycustomization(event, item, properties)
  }
}
